export default __webpack_public_path__ + "static/media/dogen.7fc0edbe.png";